import React, { FormEvent, useContext, useEffect, useState } from "react";
import style from "./index.module.scss";
import { useHistory, useParams } from "react-router-dom";
import { Button, Input } from "antd";
import DetailLayout from "../../../components/DetailLayout";
import CourseHeader from "../../../components/CourseHeader";
import { CourseContext } from "../../../Store";
import TableList from "./Components/TableList";
import { getAllGroupMemberGradeList } from "../../../../../service/group";
import { useAtomValue } from "jotai";
import { groupStaticsListAtom } from "../../store";
import useRequestFn from "utils/useRequestFn";
import { ResultMessage } from "components/ResultMessage";
import { errorMessage } from "service/service";

export default function MembersList() {
    const history = useHistory();
    const { activityId } = useParams();
    const { basename } = useContext(CourseContext);
    const staticsData = useAtomValue(groupStaticsListAtom);
    const [text, setText] = useState("");

    const [getList, { loading, data }] = useRequestFn(
        getAllGroupMemberGradeList
    );

    useEffect(() => {
        getList(activityId, text).catch(e =>
            ResultMessage.error(errorMessage(e))
        );
    }, []);

    function onConfirmSearch(e: FormEvent) {
        e.preventDefault();
        getList(activityId, text);
    }

    return (
        <DetailLayout breadcrumb="小组详情">
            <CourseHeader
                title={staticsData?.activity.activityName || ""}
                info={
                    <div className={style.info}>
                        截止时间：{staticsData?.activity.deadlineStr}
                    </div>
                }
                extra={
                    <Button
                        type="link"
                        className={style.link}
                        onClick={() =>
                            history.replace(
                                `${basename}/group/detail/${activityId}`
                            )
                        }>
                        <img src={require("./img/icon.png")} />
                        查看小组得分
                    </Button>
                }
            />

            <form className={style.filter} onSubmit={onConfirmSearch}>
                <Input
                    className={style.input}
                    placeholder="请输入小组名称及关键词"
                    onChange={e => setText(e.target.value)}
                />
                <Button htmlType="submit" type="primary" icon="search">
                    查询
                </Button>
            </form>
            <TableList data={data || []} loading={loading} />
        </DetailLayout>
    );
}
